import type { ServiceEntry } from '@/types/domain';
import { useFirestoreDoc } from './useFirestoreDoc';

/**
 * Subscribes to a single service entry document at
 * `vehicles/{vehicleId}/service/{entryId}`.
 */
export function useServiceEntry(
  vehicleId: string | null | undefined,
  entryId: string | null | undefined,
) {
  return useFirestoreDoc<ServiceEntry>(
    vehicleId && entryId ? `vehicles/${vehicleId}/service` : null,
    vehicleId && entryId ? [entryId] : [],
  );
}
